export const PERMISSION = [
  { label: '세무사 상담', code: 'TAX_COUNSELING' },
  { label: '노무사 상담', code: 'LABOR_COUNSELING' },
  { label: "할일", code: "TODO" },
  { label: '커뮤니티', code: 'COMMUNITY' },
  { label: "나의 출퇴근 기록", value: "COMMUTE_HISTORY" },
  { label: "출퇴근 관리", value: "COMMUTE_MANAGEMENT" },
  { label: "근로시간 관리", value: "WORK_TIME_MANAGEMENT" },
  { label: "부서별 근무 현황", value: "WORK_HISTORY" },
  { label: "출퇴근 장소 관리", value: "WORK_PLACE_MANAGEMENT" },
  { label: "근무일정 관리", value: "WORK_SCHEDULE_MANAGEMENT" },
  { label: "공통 휴일", value: "HOLIDAY" },
  { label: "기타 근무 항목 설정", value: "OTHER_WORK_MANAGEMENT" },
  { label: "휴가 실적 및 계획", value: "VACATION_PLAN" },
  { label: "휴가 부여 현황", value: "ADDED_VACATION_HISTORY" },
  { label: "연차 기준 관리", value: "VACATION_LEAVE_MANAGEMENT" },
  { label: "기타 휴가 관리", value: "OTHER_VACATION_MANAGEMENT" },
  { label: "나의 급여 조회", value: "SALARY" },
  { label: "급여 내역 관리", value: "SALARY_HISTORY_MANAGEMENT" },
  { label: "급여 항목 관리", value: "SALARY_ITEM_MANAGEMENT" },
  { label: "사람", value: "USER" },
  { label: "전자계약서", value: "CONTRACT" },
  { label: "리포트", value: "FUND_REPORT" },
  { label: "자금 일보", value: "FUND_JOURNAL" },
  { label: "은행 입출금 내역", value: "FUND_BANK_HISTORY" },
  { label: "신용카드 내역", value: "FUND_CARD_HISTORY" },
  { label: "거래처별 채권채무", value: "FUND_CLAIM_OBLIGATION" },
  { label: "거래명세서", value: "TRADE_INVOICE" },
  { label: "전자 세금계산서", value: "TAX_INVOICE" },
  { label: "현금영수증", value: "CASH_INVOICE" },
  { label: "경비청구", value: "EXPENSE" },
  { label: "업로드 내역", value: "UPLOAD_HISTORY" },
  { label: "회사 정보관리", value: "COMPANY_MANAGEMENT" },
  { label: "업무 담당자 관리", value: "WORK_MANAGER_MANAGEMENT" },
  { label: "외부 담당자 관리", value: "OUTSIDE_MANAGER_MANAGEMENT" },
  { label: "금융 정보 자동 수집관리", value: "FINANCE_SCRAPING" },
  { label: "사업장 정보 관리", value: "COMPANY_PLACE_MANAGEMENT" },
  { label: "품목", value: "PRODUCT" },
  { label: "거래처", value: "COMPANY_ACCOUNT" },
  { label: "알림", value: "NOTIFICATION" },
  { label: "공지사항", value: "NOTICE" },
];